export default __webpack_public_path__ + "alberta-produce.93ab19c5350fef9dfb4d.svg";